<template>
    <div class="my-profile">
        <v-layout row wrap>
            <v-flex xs12 class="events_banner">
                <v-flex class="awards_block">
                    <strong text-xs-left>{{myAccountConstants.myProfileConstants.MY_PROFILE_TITLE}}</strong>
                    <v-flex class="edit-profile">
                        <v-btn fab flat  data-qe-id="MyProfileEditBtn">
                            <v-icon color="white">edit</v-icon>
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-flex>
            <router-view></router-view>
        </v-layout>
    </div>
</template>

<script>
import { myAccountConstants } from "./myaccount.constants.js";

export default {
    name: "MyProfile",
    data: () => ({
        myAccountConstants,
    }),
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';

.my-profile {
    margin-top: 55px;
}

.edit-profile {
    padding-top: 20px;
}

.events_banner {
    background: linear-gradient(0deg, $ypo-blue 0%, #041A2C 100%);
    position: relative;
    min-height: 150px;
    background-size: cover;
    background-position: center;
    margin-top: 10px;

    &:before {
        content: '';
        background: rgba($ypo_blue, 0.5);
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .awards_block {
        position: inherit;
        left: 29px;
        top: 20px;
        z-index: 1;
        color: $white;
        font-family: 'Raleway', sans-serif;

        strong {
            float: left;
            display: block;
            font-size: 30px;
            font-weight: 500;
            letter-spacing: -0.74px;
            line-height: 110px;
        }
    }
}
</style>
